const NavLogo = () => {
    return <img id="NavLogo" src="Assets/Icons/logo_2.png" alt="logo2" />;
};

export default NavLogo;
